<template>
  <div class="content-reviews">
    <div v-if="lexicon && reviews && reviews.reviews && reviews.reviews.length > 0">
      <div class="top sm:mb-2 mb-0">
        <div class="flex justify-center">
          <div class="pt-1 pb-2 sm:pb-6">
            <StarRating :increment="0.1" :rating="reviews.average" read-only :star-size="30" />

            <h4 class="mt-4 text-xs sm:text-base">
              {{ reviews.total }} {{ lexicon.reviews }}
              {{ lexicon.from_verified_users }}
            </h4>
          </div>
        </div>
      </div>
      <div class="filter-bar flex justify-between items-center p-2 sm:p-4 mb-2 bg-gray-100 h-auto flex-col sm:flex-row">
        <div>
          <label class="flex justify-center items-center">
            <input type="checkbox" v-model="showTextReviewsOnly"
              style="margin: 0 !important; margin-right: 3px !important" />
            {{ lexicon.show_text_rating }}
          </label>
        </div>
        <div>
          <select v-model="selectedSortOption"
            class="mb-0 outline-none mt-2 sm:mt-auto text-sm sm:text-base h-6 sm:h-auto">
            <option v-for="(option, index) in sortOptions" :key="`option-${index}`" :value="option">
              {{ option }}
            </option>
          </select>
        </div>
      </div>
      <div class="ratings relative">
        <div v-for="(item, index) in visibleReviews" :key="`item-${index}`"
          class="flex gap-4 sm:gap-10 justify-center py-4 border-b border-gray-300 flex-col sm:flex-row items-start sm:item-center"
          style="overflow-wrap: anywhere">
          <div class="px-0 sm:px-6">
            <StarRating :increment="0.1" :rating="item.rating" read-only :star-size="20" />
          </div>
          <div class="flex flex-col flex-grow items-start justify-between sm:flex-row sm:items-center">
            <div>
              <div class="flex flex-row items-center">
                <div class="border border-gray-600 h-9 mr-4 rounded-full w-9">
                  <img class="object-cover w-full h-full rounded-full" :src="item.gravatar" />
                </div>
                <div class="text-left">
                  <b style="font-weight: bold !important">
                    {{ item.name }} {{ item.surname }}
                    <font-awesome-icon :icon="['fas', 'circle-check']" style="color: #00e1ff" />
                  </b>
                  <br />
                  <!-- <span class="text-gray-600 text-sm pt-2 italic">17 αξιολογησεις</span> -->
                </div>
              </div>

              <div v-if="item.text" class="text-left mt-2 sm:mt-5">
                <p class="pr-2">{{ item.text }}</p>
              </div>

              <!-- <div class="bottom-bar mt-10 mb-2 flex flex-row gap-3">
                <div @click="likeItem({ item, index })" class="cursor-pointer">
                  <font-awesome-icon :icon="['fas', 'thumbs-up']" />
                </div>
                <div @click="shareItem({ item, index })" class="cursor-pointer">
                  <font-awesome-icon :icon="['fas', 'share-nodes']" />
                </div>
                <div class="italic text-gray-600">
                  17 στους 30 την βρήκαν χρήσιμη
                </div>
              </div> -->
            </div>
            <div class="text-gray-400 text-sm px-0 sm:px-2 pt-2 sm:pt-0 min-w-max"
              v-if="item.orderCreatedAt && dateFormat">
              {{ lexicon.purchase_date }}:
              {{ dayjs(item.orderCreatedAt).fromNow() }}
            </div>
          </div>
        </div>
      </div>
      <div class="mt-3 sm:mt-5 w-full justify-center items-center flex" v-if="totalReviews">
        <Pagination v-model="page" :records="totalReviews" @paginate="paginate" :per-page="perPage"
          :options="paginationOptions" />
      </div>
    </div>
  </div>
</template>

<script>
import StarRating from "vue-star-rating";
import Pagination from "vue-pagination-2";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import "dayjs/locale/el";
import "dayjs/locale/da";
import "dayjs/locale/cs";
import "dayjs/locale/sv";
import "dayjs/locale/ro";

import { isMobile } from "@/assets/helpers.js";

export default {
  name: "RatingsView",
  components: {
    Pagination,
    StarRating,
  },
  props: ["reviews", "dateFormat", "lexicon"],
  data() {
    return {
      sortOptions: [],
      selectedSortOption: null,
      page: 1,
      dayjs: dayjs.extend(relativeTime),
      perPage: 30,
      showTextReviewsOnly: false,
      paginationOptions: {
        texts: {
          count: `{from} μέχρι {to} από {count} αξιολογήσεις`,
        },
      },
    };
  },
  watch: {
    selectedSortOption() {
      this.page = 1;
    },
    showTextReviewsOnly() {
      this.page = 1;
    },
  },
  computed: {
    visibleReviews() {
      if (!this.reviews || !this.reviews?.reviews) return [];

      let reviews = JSON.parse(JSON.stringify(this.reviews?.reviews));

      if (this.showTextReviewsOnly)
        reviews = reviews.filter(review => !!review.text);

      if (this.selectedSortOption === this.sortOptions[2]) {
        reviews.sort((a, b) => (a.rating > b.rating ? 1 : -1));
      } else if (
        this.selectedSortOption === this.sortOptions[1] ||
        this.selectedSortOption === this.sortOptions[2]
      ) {
        reviews.sort((a, b) => (a.rating > b.rating ? -1 : 1));
      } else if (this.selectedSortOption === this.sortOptions[3]) {
        reviews.sort((a, b) => {
          const aDate = dayjs(a.reviewCreatedAt);
          const bDate = dayjs(b.reviewCreatedAt);

          return aDate.diff(bDate) > 0 ? -1 : 1;
        });
      }

      reviews = reviews?.filter((review, index) => {
        let pass = false;

        if (index <= this.page * this.perPage) pass = true;
        if (this.page >= 0) {
          if (index < (this.page - 1) * this.perPage) pass = false;
        }
        return pass;
      });

      return reviews;
    },
    totalReviews() {
      return this.showTextReviewsOnly
        ? this.reviews?.reviews?.filter(review => !!review.text)?.length
        : this.reviews?.reviews?.length;
    },
  },
  methods: {
    likeItem({ item, index }) {
      console.log("like item: ", item, index);
    },
    shareItem({ item, index }) {
      console.log("share item: ", item, index);
    },
    paginate(...args) {
      this.page = args?.[0];
    },
    initStuff() {
      // console.log('init stuff', this.lexicon)
      const locale = window?.productReviews?.options?.locale?.replace(/_[A-Za-z]*/, '')

      if (locale)
        dayjs.locale(locale);
      this.sortOptions = [
        this.lexicon?.default_sorting,
        this.lexicon?.high_ratings,
        this.lexicon?.low_ratings,
        this.lexicon?.recent_ratings,
      ];
      this.selectedSortOption = this.sortOptions[0];

      this.paginationOptions.texts.count = `{from} ${this.lexicon?.to} {to} ${this.lexicon?.from} {count} ${this.lexicon?.reviews}`;
    },
  },
  beforeMount() {
    if (isMobile()) {
      this.paginationOptions.chunk = 3;
    }
  },
  mounted() {
    this.initStuff();
  },
};
</script>

<style lang="scss" scoped>
.content-reviews {
  min-width: 80vw;
}

.ratings {
  max-height: 460px;
  max-height: calc(80vh - 400px);
  overflow-y: auto;

  @media screen and (max-width: 600px) {
    max-height: calc(90vh - 400px);

    &::-webkit-scrollbar {
      -webkit-appearance: none;
      -webkit-overflow-scrolling: auto
    }

    &::-webkit-scrollbar:vertical {
      width: 12px;
    }

    &::-webkit-scrollbar:horizontal {
      height: 12px;
    }

    &::-webkit-scrollbar-thumb {
      background-color: rgba(0, 0, 0, .5);
      border-radius: 10px;
      border: 2px solid #ffffff;
    }

    &::-webkit-scrollbar-track {
      border-radius: 10px;
      background-color: #ffffff;
    }

    background:
    /* Shadow Cover TOP */
    linear-gradient(white 30%,
      rgba(255, 255, 255, 0)) center top,

    /* Shadow Cover BOTTOM */
    linear-gradient(rgba(255, 255, 255, 0),
      white 70%) center bottom,

    /* Shadow TOP */
    radial-gradient(farthest-side at 50% 0,
      rgba(0, 0, 0, 0.2),
      rgba(0, 0, 0, 0)) center top,

    /* Shadow BOTTOM */
    radial-gradient(farthest-side at 50% 100%,
      rgba(0, 0, 0, 0.2),
      rgba(0, 0, 0, 0)) center bottom;

    background-repeat: no-repeat;
    background-size: 100% 40px,
    100% 40px,
    100% 14px,
    100% 14px;
    background-attachment: local,
    local,
    scroll,
    scroll;
  }
}
</style>

<style lang="scss">
li.VuePagination__pagination-item.page-item {
  display: inline-block;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 0px;
  background: #fff;
  width: 50px;
  border-right: none;
  text-align: center;
  cursor: pointer;
  user-select: none;

  @media screen and (max-width: 600px) {
    padding: 5px;
    width: 35px;
    height: 35px;
    padding-top: 4px;
  }

  &:hover,
  &.active {
    background: darkslateblue;
    border-color: darkslateblue;

    a.page-link {
      color: white;
    }
  }

  a.page-link {
    color: darkslateblue;
    font-weight: 500;

    @media screen and (max-width: 600px) {
      font-size: 14px;
    }
  }

  &.disabled {
    // background: #ddd !important;
    cursor: not-allowed;

    &:hover {
      background: white;
      border-color: #ddd;

      a.page-link {
        color: initial;
        cursor: not-allowed;
      }
    }
  }
}

p.VuePagination__count.VuePagination__count {
  text-align: center;
}

.VuePagination__pagination-item-next-chunk {
  border-right: 1px solid #ddd !important;
  border-top-right-radius: 5px !important;
  border-bottom-right-radius: 5px !important;
}

.VuePagination__pagination-item-prev-chunk {
  border-top-left-radius: 5px !important;
  border-bottom-left-radius: 5px !important;
}

ul.VuePagination__pagination.pagination.VuePagination__pagination {
  @media screen and (max-width: 600px) {
    margin-bottom: 10px;
  }
}
</style>
